import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import React from "react";
import Media from "../../../components/Media/Media";
import { Panel } from 'primereact/panel';

export default function P206PicList({ data, setDialog, disabledPage }) {
    const carouselResponsiveOptions = [
        {
            breakpoint: "1280px",
            numVisible: 3,
            numScroll: 4,
        },
        {
            breakpoint: "1024px",
            numVisible: 2,
            numScroll: 4,
        },
        {
            breakpoint: "768px",
            numVisible: 2,
            numScroll: 2,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
            numScroll: 1,
        },
    ];

    const carouselItemTemplate = (data) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="p-mb-3">
                        <Media path={data.profilePhotoPath} alt={data.inspectorName} type="images" typefile="person" style={{ width: 120, height: 124 }} className="" />
                    </div>
                    <div>
                        <h5 className="p-mb-1">{data.inspectorName}</h5>
                        <br />
                        <span
                            style={{
                                background: data.selectFlag === "Y" ? "#c8e6c9" : "#ffcdd2",
                                color: data.selectFlag === "Y" ? "#256029" : "#c63737",
                                borderRadius: "2px",
                                padding: ".25em .5rem",
                                textTransform: "uppercase",
                                fontWeight: "700",
                                fontSize: "14px",
                                letterSpacing: ".3px",
                            }}
                        >
                            {data.selectFlag == "Y" ? "ปฏิบัติงาน" : "ไม่ได้ปฏิบัติงาน"}
                        </span>
                    </div>
                </div>
            </div>
        );
    };
    const _filter = () => {
        return data.filter((data) => {
            return data.selectFlag === "Y";
        });
    };
    return (
        <div>
            <div className="p-grid p-fluid media-demo">
                <div className="p-col-12">
                    <Panel header="ผู้ปฏิบัติงาน">
                        <div className="p-col-12">{_filter() && _filter().length > 0 ? <Carousel value={_filter()} numVisible={4} numScroll={3} responsiveOptions={carouselResponsiveOptions} itemTemplate={carouselItemTemplate}></Carousel> : ""}</div>

                        <div className="p-col-12" style={{ textAlign: "center" }}>
                            <Button
                                className="p-button-warning p-button p-md-12 "
                                icon="fas fa-user-plus"
                                label="เลือกผู้ปฏิบัติงาน "
                                // style={{ marginLeft: '5px' }}
                                style={{ width: 150, marginLeft: "5px", marginTop: "10px" }}
                                onClick={() => setDialog({ dialog: true, action: "บันทึก" })}
                                disabled={disabledPage}
                            />
                        </div>
                    </Panel>
                </div>
            </div>
        </div>
    );
}
